<template>
  <v-layout align-start>
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll>
          <v-toolbar-title
            >Detalle del Presupuesto de Marketing</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="false"
                class="mx-2"
                icon
                large
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="!presupSelect"
              >
                <v-icon dark> download </v-icon>
                <download-excel
                  class="btn btn-default"
                  :data="vistas"
                  worksheet="Hoja 1"
                  :name="
                    'Reporte ' +
                    new Date().getFullYear() +
                    (new Date().getMonth() + 1) +
                    new Date().getDate() +
                    ' ' +
                    new Date().getHours() +
                    new Date().getMinutes() +
                    new Date().getSeconds()
                  "
                >
                  .
                </download-excel>
              </v-btn>
            </template>
            <span>Descarga de Archivo Excel</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="false"
                class="mx-2"
                icon
                large
                color="primary"
                @click="mostrarDialogVista()"
                v-bind="attrs"
                v-on="on"
                :disabled="!presupSelect"
              >
                <v-icon dark> pivot_table_chart </v-icon>
              </v-btn>
            </template>
            <span>Ver Presupuesto anual</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="false"
                icon
                large
                @click="mostrarCarga"
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="!presupSelect"
              >
                <v-icon dark> file_upload </v-icon>
              </v-btn>
            </template>
            <span>Carga masiva de datos</span>
          </v-tooltip>
          <div
            v-if="
              !(
                    id_presupuesto === 1 ||
                    id_presupuesto === 2 ||
                    id_presupuesto === 3 ||
                    id_presupuesto === 4 ||
                    id_presupuesto === 5 ||
                    id_presupuesto === 6
                  )
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="addItem"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!presupSelect"
                >
                  <v-icon dark> add </v-icon>
                </v-btn>
              </template>
              <span>Ingresar nuevo registro</span>
            </v-tooltip>
            <v-tooltip bottom v-if="multiple">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="mostrarDialogBorrar"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!presupSelect"
                >
                  <v-icon dark> fa-solid fa-trash </v-icon>
                </v-btn>
              </template>
              <span>Eliminar Registros</span>
            </v-tooltip>
            <v-tooltip bottom v-if="multiple">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="mostrarDialogDuplicar"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!presupSelect"
                >
                  <v-icon dark> fa-solid fa-clone </v-icon>
                </v-btn>
              </template>
              <span>Copiar a la siguiente gestión</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="multiple = !multiple"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!presupSelect"
                >
                  <v-icon dark>{{
                    multiple ? "fa-solid fa-list" : "fa-solid fa-list-check"
                  }}</v-icon>
                </v-btn>
              </template>
              <span>{{
                multiple
                  ? "Editar registros individuales"
                  : "Seleccionar varios registros"
              }}</span>
            </v-tooltip>
          </div>
        </v-app-bar>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="3" md="3">
              <v-autocomplete
                outlined
                dense
                ref="id_presupuesto"
                v-model="id_presupuesto"
                @change="cambiarPresupuesto"
                :items="presupuestos"
                :rules="[rules.requerido]"
                :error-messages="errorMessages"
                :loading="cargandoPresupuesto"
                :disabled="cargandoPresupuesto"
                item-text="descripcion"
                item-value="id"
                label="Presupuesto"
                required
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Búsqueda General"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-autocomplete
                dense
                outlined
                class="text-xs-center"
                v-model="searchCuentaValue"
                :items="presupuesto_lineas"
                append-icon="search"
                label="Búsqueda por Cuenta"
                item-text="cuenta_contable"
                item-value="cuenta_contable"
                clearable
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-autocomplete
                outlined
                dense
                v-model="searchMesValue"
                :items="meses"
                append-icon="search"
                label="Búsqueda por mes"
                item-text="descripcion"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-sheet class="overflow-y-auto" :max-height="windowHeigth - 200">
          <v-data-table
            dense
            fixed-header
            :height="windowHeigth - 300"
            :headers="
              multiple ? headers.filter((h) => h.value !== 'opciones') : headers
            "
            :items="presupuesto_lineas"
            :items-per-page="2"
            :search="search"
            v-model="selectLineaPresupuesto"
            :show-select="multiple"
            :loading="cargandoPresupuesto"
            loading-text="Cargando datos del presupuesto..."
            sort-by="mes"
            class="elevation-1"
            show-group-by
            :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-text': 'Filas por página',
              'group-text': 'Agrupar',
              'items-per-page-options': [50, 100, 150, -1],
            }"
          >
            <template v-slot:[`item.selected`]="{ item }">
              <v-checkbox v-model="item.selected"></v-checkbox>
            </template>

            <template v-slot:[`group.header`]="{ group, items, headers, toggle, isOpen }">
              <td :colspan="headers.length">
                <v-btn
                  @click="toggle"
                  x-small
                  icon
                  :disabled="!group"
                >
                  <v-icon>{{ isOpen ? 'fa-solid fa-minus' : 'fa-solid fa-plus' }}</v-icon>
                </v-btn>
                <span class="font-weight-bold">{{ group }} ({{ items.length }} elementos)</span>
                <span class="font-weight-bold ml-4 primary--text">
                  Subtotal: {{ $formatoNumero(calcularSubtotal(items)) }}
                </span>
                <!-- Botón de edición en grupo - solo aparece cuando se agrupa por detalle -->
                <v-btn
                  v-if="esAgrupadoPorDetalle(group)"
                  @click="abrirEdicionEnGrupo(items, group)"
                  x-small
                  color="primary"
                  class="ml-4"
                  :disabled="items.length === 0"
                >
                  <v-icon x-small>fa-solid fa-edit</v-icon>
                  Editar Grupo
                </v-btn>
              </td>
            </template>

            <template v-slot:[`item.opciones`]="{ item }">
              <div
                v-if="
                  !(
                    id_presupuesto === 1 ||
                    id_presupuesto === 2 ||
                    id_presupuesto === 3 ||
                    id_presupuesto === 4 ||
                    id_presupuesto === 5 ||
                    id_presupuesto === 6
                  )
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      text
                      dark
                      color="primary"
                      @click="editItem(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon x-small>fa-soli fa-pen</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Línea</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      text
                      dark
                      color="primary"
                      @click="mostrarDialogBorrar(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon x-small>fa-solid fa-trash</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar Registro</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      text
                      dark
                      color="primary"
                      @click="mostrarDialogDuplicar(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon x-small>fa-solid fa-clone</v-icon>
                    </v-btn>
                  </template>
                  <span>Copiar a la siguiente gestión</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:[`item.mes`]="{ item }">
              <div>
                {{ item.mes === null ? "" : enteroaMeses(item.mes, true) }}
              </div>
            </template>
            <template v-slot:[`item.monto`]="{ item }">
              <div>
                {{ $formatoNumero(item.monto) }}
              </div>
            </template>

            <template v-slot:footer>
              <div class="font-weight-bold text-right primary--text">
                Total Bs.:

                {{ $formatoNumero(totalMonto) }}
              </div>
            </template>

            <template v-slot:no-data> No hay información disponible </template>
          </v-data-table>
        </v-sheet>
      </v-card>

      <v-dialog v-model="dialogUpload" max-width="50%">
        <v-card>
          <v-card-title>
            <span class="headline">Carga Masiva de Datos</span>
          </v-card-title>
          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="cancel_presentation"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeUpload">Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarExcel">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogTablaVista" persistent max-width="100%">
        <v-card>
          <v-card-title class="headline">Presupuesto por Año</v-card-title>
          <v-card-text>
            <v-data-table
              dense
              :headers="headersVista"
              :items="vistas"
              :items-per-page="2"
              :search="search"
              sort-by="producto"
              class="elevation-1"
              show-group-by
              :header-props="{
                'sort-icon': 'fa-solid fa-arrow-down-wide-short',
              }"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-text': 'Filas por página',
                'group-text': 'Agrupar',
                'items-per-page-options': [50, 100, 150, -1],
              }"
            >
              <template v-slot:[`item.opciones`]="{ item }">
                <v-btn
                  x-small
                  text
                  dark
                  color="primary"
                  @click="editItem(item)"
                >
                  <v-icon x-small>edit</v-icon>
                </v-btn>
              </template>

              <template v-slot:no-data>
                <span>No hay elementos para mostrar</span>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn text @click="dialogTablaVista = false">
              <download-excel
                class="btn btn-default"
                :data="vistas"
                worksheet="Hoja 1"
                :name="
                  'Reporte ' +
                  new Date().getFullYear() +
                  (new Date().getMonth() + 1) +
                  new Date().getDate() +
                  ' ' +
                  new Date().getHours() +
                  new Date().getMinutes() +
                  new Date().getSeconds()
                "
              >
                Exportar a Excel
              </download-excel>
            </v-btn>
            <v-btn text @click="dialogTablaVista = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogPresupuestoLinea"
        persistent
        :max-width="windowWidth < 1000 ? '100%' : '50%'"
      >
        <v-card ref="form">
          <v-app-bar color="white" elevate-on-scroll>
            <v-toolbar-title class="font-weight-black primary--text">{{
              formTitle
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <div v-show="!mensajeError">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-2"
                    icon
                    large
                    color="primary"
                    @click="guardar()"
                    v-bind="attrs"
                    v-on="on"
                    :disabled="!presupSelect"
                  >
                    <v-icon dark> save </v-icon>
                  </v-btn>
                </template>
                <span>Guardar Registro(s)</span>
              </v-tooltip>
            </div>
            <div v-show="mensajeError">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    large
                    @click="mostrarDialogReemplazar"
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    :disabled="!presupSelect"
                  >
                    <v-icon dark> save_as </v-icon>
                  </v-btn>
                </template>
                <span>Guardar y Reemplazar</span>
              </v-tooltip>
            </div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="close"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!presupSelect"
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cerrar</span>
            </v-tooltip>
          </v-app-bar>
          <v-card-text>
            <v-container>
              <div v-show="mensajeError">
                <v-alert text dense color="error" icon="warning" border="left">
                  <v-row align="center">
                    <v-col class="grow">
                      Algunos registros ya fueron realizados.
                    </v-col>
                    <v-col class="shrink">
                      <v-btn x-small color="error" @click="snackbar = true"
                        >Detalles</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-alert>
              </div>

              <v-snackbar v-model="snackbar" :multi-line="true" color="error">
                <pre>{{ error }}</pre>

                <template v-slot:action="{ attrs }">
                  <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                  >
                    Close
                  </v-btn>
                </template>
              </v-snackbar>

              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    outlined
                    dense
                    ref="id_cuenta_contable"
                    v-model="itemPresupuestoLinea.id_cuenta_contable"
                    :items="cuentasContables"
                    :rules="[rules.requerido]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Cuenta Contable"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    outlined
                    dense
                    :readonly="esRolSoloLectura"
                    ref="id_centro_costo"
                    v-model="itemPresupuestoLinea.id_centro_costo"
                    :items="centroCostos"
                    :rules="[rules.requerido]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Centro de Costo"
                    required
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    outlined
                    dense
                    :readonly="esRolSoloLectura"
                    ref="id_servicio"
                    v-model="itemPresupuestoLinea.id_servicio"
                    :items="servicios"
                    :rules="[]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Servicio/Medio de Comunicación"
                    :search-input.sync="nuevoServicio"
                    required
                  >
                    <template v-slot:no-data>
                      <div v-if="nuevoServicio == null || nuevoServicio == ''">
                        <p>No hay información disponible</p>
                      </div>
                      <div v-else>
                        <v-btn
                          plain
                          tile
                          color="primary"
                          @click="abrirAgregarServicio()"
                        >
                          <v-icon left> add </v-icon>
                          Agregar Servicio
                        </v-btn>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    outlined
                    dense
                    :readonly="esRolSoloLectura"
                    ref="id_tipo_aprobacion"
                    v-model="itemPresupuestoLinea.id_tipo_aprobacion"
                    :items="tipoAprobaciones"
                    :rules="[]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Aprobación"
                    required
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    outlined
                    dense
                    chips
                    deletable-chips
                    multiple
                    ref="id_familia"
                    v-model="itemPresupuestoLinea.id_familia"
                    @change="validarDuplicados"
                    :readonly="editedIndex"
                    :items="familias"
                    :rules="[rules.requerido2]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Familia"
                    required
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-textarea
                    outlined
                    dense
                    ref="detalle"
                    v-model="itemPresupuestoLinea.detalle"
                    :readonly="esEdicionGrupo"
                    :rules="[rules.requerido]"
                    :error-messages="errorMessages"
                    label="Detalle"
                    placeholder="Detalle"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    outlined
                    dense
                    chips
                    deletable-chips
                    multiple
                    ref="mes"
                    v-model="itemPresupuestoLinea.mes"
                    @change="validarDuplicados"
                    :readonly="editedIndex"
                    :items="meses"
                    :rules="[rules.requerido2]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Mes"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    reverse
                    ref="monto"
                    v-model="itemPresupuestoLinea.monto"
                    @change="validarDuplicados"
                    @keydown="validarDuplicados"
                    :rules="[rules.requerido, rules.numero, rules.mayorCero]"
                    :error-messages="errorMessages"
                    label="Monto(Bs.)"
                    placeholder="Monto(Bs.)"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogReemplazar" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción reemplazará los registros realizados anteriormente
            según el detalle mostrado en el mensaje de alerta. ¿Desea
            continuar?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogReemplazar = false">Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarReemplazar()"
              >Continuar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAgregarServicio" max-width="500px">
        <v-card ref="form">
          <v-card-title>
            <span class="headline">Agregar Servicio</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    ref="codigoServicio"
                    v-model="codigoServicio"
                    :rules="[rules.requerido, rules.max10, rules.min2]"
                    :error-messages="errorMessages"
                    label="Código"
                    placeholder="Código"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    ref="descripcionServicio"
                    v-model="descripcionServicio"
                    :rules="[rules.requerido, rules.max50, rules.min2]"
                    :error-messages="errorMessages"
                    label="Descripción"
                    placeholder="Descripción"
                    required
                  ></v-text-field>

                  <v-autocomplete
                    outlined
                    dense
                    ref="id_nitServicio"
                    v-model="id_nitServicio"
                    :items="nitsServicio"
                    :rules="[]"
                    label="Nit Facturación"
                    item-text="descripcion"
                    item-value="id"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeServicio">Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarServicio">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogBorrar" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text v-if="multiple">
            Esta acción borrará las líneas seleccionadas, y ya no figurarán en
            el presupuesto. ¿Desea continuar?</v-card-text
          >
          <v-card-text v-else
            >Esta acción borrará la línea seleccionada, y ya no figurará en el
            presupuesto. ¿Desea continuar?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogBorrar = false">Cancelar</v-btn>
            <v-btn
              color="primary"
              text
              @click="multiple ? borrarItems() : borrarItem()"
              >Continuar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDuplicar" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text v-if="multiple">
            Esta acción duplicará las líneas seleccionadas, y figurarán en el
            presupuesto de la siguiente gestión en el mismo mes o meses. ¿Desea
            continuar?
          </v-card-text>
          <v-card-text v-else>
            Esta acción duplicará la línea seleccionada, y figurará en el
            presupuesto de la siguiente gestión en el mismo mes. ¿Desea
            continuar?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogDuplicar = false">Cancelar</v-btn>
            <v-btn
              color="primary"
              text
              @click="multiple ? duplicarItems() : duplicarItem()"
              >Continuar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

    
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import Servicio from "./Servicio.vue";

export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeigth: window.innerHeight,
      presupuesto_lineas: [],
      presupuestos: [],
      familias: [],
      servicios: [],
      cuentasContables: [],
      nitsServicio: [],
      centroCostos: [],
      tipoAprobaciones: [],
      vistas: [],
      itemPresupuestoLinea: {},
      meses: [
        { id: 1, descripcion: "ENERO" },
        { id: 2, descripcion: "FEBRERO" },
        { id: 3, descripcion: "MARZO" },
        { id: 4, descripcion: "ABRIL" },
        { id: 5, descripcion: "MAYO" },
        { id: 6, descripcion: "JUNIO" },
        { id: 7, descripcion: "JULIO" },
        { id: 8, descripcion: "AGOSTO" },
        { id: 9, descripcion: "SEPTIEMBRE" },
        { id: 10, descripcion: "OCTUBRE" },
        { id: 11, descripcion: "NOVIEMBRE" },
        { id: 12, descripcion: "DICIEMBRE" },
      ],
      dialogPresupuestoLinea: false,
      dialogUpload: false,
      dialogReplicar: false,
      dialogReemplazar: false,
      dialogBorrar: false,
      dialogDuplicar: false,
      dialogTablaVista: false,
      presupSelect: false,
      mensajeError: false,
      multiple: false,
      selectLineaPresupuesto: [],
      cargandoPresupuesto: false, // Variable para controlar la animación de carga
      
      // Variables para edición en grupo
      grupoSeleccionado: '',
      itemsGrupoSeleccionado: [],
      mesesSeleccionados: [],
      familiasSeleccionadas: [],
      esEdicionGrupo: false, // Indica si el diálogo se abrió desde "Editar Grupo"
      
      usuario: this.$store.state.usuario.user,
      codigoSac: this.$store.state.usuario.codigoSac,
      rol: this.obtenerRolPrincipal(),
      page: 1,
      itemsPerPage: 12,
      headers: [
        {
          text: "Opciones",
          value: "opciones",
          groupable: false,
          sortable: false,
          width: "10%",

          align: this.multiple ? " d-none" : "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cuenta Contable",
          value: "cuenta_contable",
          align: "left",
          filter: this.filtroCuenta,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Centro Costo",
          value: "centro_costo",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Mes",
          value: "mes",
          align: "left",
          filter: this.filtroMes,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Servicio",
          value: "servicio",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Familia",
          value: "familia",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Tipo de Aprobación",
          value: "tipo_aprobacion",
          align: "left",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Detalle",
          value: "detalle",
          align: "left",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Monto (Bs.)",
          value: "monto",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
      ],

      headersVista: [
        {
          text: "Cuenta Contable",
          value: "desc_cuc",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Centro Costo",
          value: "desc_cco",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Servicio",
          value: "desc_serv",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Producto",
          value: "desc_fam",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Enero",
          value: "enero",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Febrero",
          value: "febrero",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Marzo",
          value: "marzo",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Abril",
          value: "abril",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Mayo",
          value: "mayo",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Junio",
          value: "junio",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Julio",
          value: "julio",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Agosto",
          value: "agosto",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Septiembre",
          value: "septiembre",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Octubre",
          value: "octubre",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Noviembre",
          value: "noviembre",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Diciembre",
          value: "diciembre",
          align: "right",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Total",
          value: "total",
          align: "center",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
      ],

      rules: {
        requerido: (value) => !!value || "Debe llenar este campo.",
        requerido2: (value) => !!value[0] || "Debe llenar este campo.",
        numero: (value) => {
          const pattern = /^\d*\.?\d*$/;
          return pattern.test(value) || "Ingrese un número válido.";
        },
        mayorCero: (value) => value > 0.01 || "Ingrese una monto superior.",
        GestionMin: (value) => value >= 1950 || "Ingrese una gestión superior.",
        GestionMax: (value) => value <= 2200 || "Ingrese una gestión inferior.",
        min2: (value) =>
          value.length >= 2 || "El campo tiene que tener mas de 2 caracteres.",
        min5: (value) =>
          value.length >= 5 || "El campo tiene que tener mas de 5 caracteres.",
        max10: (value) =>
          value.length <= 10 || "El campo debe tener menos de 10 caracteres.",
        max25: (value) =>
          value.length <= 25 || "El campo debe tener menos de 25 caracteres.",
        max30: (value) =>
          value.length <= 30 || "El campo debe tener menos de 30 caracteres.",
        max45: (value) =>
          value.length <= 45 || "El campo debe tener menos de 45 caracteres.",
        max50: (value) =>
          value.length <= 50 || "El campo debe tener menos de 50 caracteres.",
        max100: (value) =>
          value.length <= 100 || "El campo debe tener menos de 100 caracteres.",
        email: (value) => {
          const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
          return pattern.test(value) || "Ingrese un email válido.";
        },
      },

      search: "",
      searchCuentaValue: "",
      searchMesValue: "",

      editedIndex: false,
      editCodigo: false,
      mostrarErrores: false,

      itemPresupuestoLinea: {
        id: "",
        id_cuenta_contable: "",
        id_centro_costo: "",
        tipo_presupuesto: "COM",
        mes: [],
        detalle: "",
        monto: "0",
        id_servicio: "",
        id_familia: [],
        id_tipo_aprobacion: "",
      },
      dialogAgregarServicio: false,
      id_presupuesto: "",
      nuevoServicio: "",
      codigoServicio: "",
      descripcionServicio: "",
      id_nitServicio: "",
      tipo_presupuesto: "COM",
      snackbar: "",

      nombreExcel:
        "Reporte " +
        new Date().getFullYear() +
        (new Date().getMonth() + 1) +
        new Date().getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds(),

      file: null,

      valida: 0,

      validaMensaje: [],

      adCodigo: "",
      errorMessages: "",
      error: "",
    };
  },

  computed: {
    // Computed property para verificar si el usuario tiene rol de solo lectura (GDP/Producto)
    esRolSoloLectura() {
      return this.tieneAlgunRol(['GDP', 'Producto']);
    },

    formTitle() {
      return this.editedIndex 
        ? "Actualizar Registro"
        :  this.esEdicionGrupo
        ? "Edición de Grupo"
        : "Nuevo Registro";
    },

    form() {
      return {
        id_cuenta_contable: this.itemPresupuestoLinea.id_cuenta_contable,
        id_centro_costo: this.itemPresupuestoLinea.id_centro_costo,
        mes: this.itemPresupuestoLinea.mes,
        monto: this.itemPresupuestoLinea.monto,
        id_servicio: this.itemPresupuestoLinea.id_servicio,
        id_familia: this.itemPresupuestoLinea.id_familia,
        detalle: this.itemPresupuestoLinea.detalle,
        id_tipo_aprobacion: this.itemPresupuestoLinea.id_tipo_aprobacion,
      };
    },
    
    // Computed para determinar si el rol actual es de solo lectura
    esRolSoloLectura() {
      return this.tieneAlgunRol(['GDP', 'Producto']);
    },
    
    formServicio() {
      return {
        codigoServicio: this.codigoServicio,
        descripcionServicio: this.descripcionServicio,
        id_nitServicio: this.id_nitServicio,
      };
    },
    totalMonto() {
      return this.presupuesto_lineas.reduce(
        (acc, item) => acc + (item.monto || 0),
        0
      );
    },
  },

  watch: {
    dialogPresupuestoLinea(val) {
      val || this.close();
    },

    name() {
      this.errorMessages = "";
    },
    nuevoTipo(val) {},
  },

  created() {
    console.log("created", this.$store.state.usuario);
    this.selectPresupuesto();
    this.selectCuentasContables();
    this.selectCentroCostos();
    this.selectFamilia();
    this.selectServicio();
    this.selectAprobacion();
    this.selectNits();
  },

  methods: {
    // Método para obtener el rol principal del usuario (compatibilidad con múltiples roles)
    obtenerRolPrincipal() {
      if (this.$store.state.usuario) {
        if (this.$store.state.usuario.roles && Array.isArray(this.$store.state.usuario.roles)) {
          const rolesActivos = this.$store.state.usuario.roles.filter(r => r.activo);
          if (rolesActivos.length > 0) {
            return rolesActivos[0].nombre;
          }
        } else if (this.$store.state.usuario.rol) {
          return this.$store.state.usuario.rol;
        }
      }
      return '';
    },

    // Método para verificar si el usuario tiene alguno de los roles especificados
    tieneAlgunRol(roles) {
      if (!this.$store.state.usuario) return false;
      
      if (this.$store.state.usuario.roles && Array.isArray(this.$store.state.usuario.roles)) {
        return this.$store.state.usuario.roles.some(userRole => 
          userRole.activo && roles.includes(userRole.nombre)
        );
      } else if (this.$store.state.usuario.rol) {
        return roles.includes(this.$store.state.usuario.rol);
      }
      
      return false;
    },

    archivoCambiado(e) {
      this.selectedFile = e;
    },

    closeUpload() {
      this.dialogUpload = false;
      this.limpiarUpload();
    },

    closeServicio() {
      this.dialogAgregarServicio = false;
      this.limpiarServicio();
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/presupuesto_lineas/cargarExcel", formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.closeUpload();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    cambiarPresupuesto(id) {
      this.id_presupuesto = id;
      this.presupuesto_lineas = [];
      this.listar();
    },

    listar() {
      let me = this;
      
      // Activar la animación de carga
      me.cargandoPresupuesto = true;
      
      
      axios
        .get(
          "api/presupuesto_lineas/ListarPresupuestoCom/" +
            me.id_presupuesto +
            "/" +
            me.codigoSac
        )
        .then(function (response) {
          me.presupuesto_lineas = response.data;
          me.selectLineaPresupuesto = [];
          me.presupSelect = true;
          me.windowWidth = window.innerWidth;
          me.windowHeigth = window.innerHeight;
        })
        .catch(function (error) {
          console.log(error);
          me.$store.dispatch("setSnackbar", {
            text: "Error al cargar los datos del presupuesto",
            color: "error",
          });
        })
        .finally(function () {
          // Desactivar la animación de carga
          me.cargandoPresupuesto = false;
        });
    },
    listarVista() {
      let me = this;
      axios
        .get("api/presupuesto_lineas/listarVista/" + me.id_presupuesto)
        .then(function (response) {
          me.vistas = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectPresupuesto() {
      let me = this;
      console.log(me.usuario);
      console.log("presupuestos", me.usuario);
      axios
        .get("api/presupuestos/select")
        .then(function (response) {
          me.presupuestos = response.data;
          console.log("presupuestos", me.presupuestos);
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },
    selectCuentasContables() {
      let me = this;

      axios
        .get(
          "api/cuenta_contables/SelectTipoPresupuesto/" +
            me.tipo_presupuesto +
            "/" +
            me.usuario
        )
        .then(function (response) {
          me.cuentasContables = response.data;
          console.log("Cuentas Contables", me.cuentasContables);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectNits() {
      let me = this;
      axios
        .get("api/nits/select")
        .then(function (response) {
          me.nitsServicio = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectCentroCostos() {
      let me = this;
      axios
        .get("api/centro_costos/select")
        .then(function (response) {
          me.centroCostos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectServicio() {
      let me = this;
      axios
        .get("api/servicios/select")
        .then(function (response) {
          me.servicios = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectFamilia() {
      let me = this;

      if (me.tieneAlgunRol(["ADM", "COM", "JEF", "Administrador", "Comunicaciones", "Jefe"])) {
        axios
          .get("api/familias/select")
          .then(function (response) {
            me.familias = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        axios
          .get("api/familias/SelectPorGDP/" + me.codigoSac)
          .then(function (response) {
            me.familias = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    selectAprobacion() {
      let me = this;
      axios
        .get("api/tipo_aprobaciones/select")
        .then(function (response) {
          me.tipoAprobaciones = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    abrirAgregarServicio() {
      this.dialogAgregarServicio = true;
      this.codigoServicio = this.nuevoServicio;
      /*this.$nextTick(() => {
        this.$refs["codigo"].focus();
      });*/
    },

    mostrarCarga() {
      this.dialogUpload = true;
    },
    mostrarDialogReplicar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      } else {
        this.dialogReplicar = true;
      }
    },

    mostrarDialogReemplazar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      } else {
        this.dialogReemplazar = true;
      }
    },

    mostrarDialogBorrar(item) {
      this.dialogBorrar = true;
      if (!this.multiple) {
        this.itemPresupuestoLinea.id = item.id;
      }
    },
    mostrarDialogDuplicar(item) {
      this.dialogDuplicar = true;
      if (!this.multiple) {
        this.itemPresupuestoLinea.id = item.id;
      }
    },
    mostrarDialogVista() {
      this.dialogTablaVista = true;
      this.listarVista();
    },
    editItem(item) {
      this.itemPresupuestoLinea = Object.assign({}, item);

      // Asegurar que mes e id_familia sean arrays para los componentes múltiples
      if (!Array.isArray(this.itemPresupuestoLinea.mes)) {
        this.itemPresupuestoLinea.mes = [this.itemPresupuestoLinea.mes];
      }
      if (!Array.isArray(this.itemPresupuestoLinea.id_familia)) {
        this.itemPresupuestoLinea.id_familia = [
          this.itemPresupuestoLinea.id_familia,
        ];
      }

      this.editedIndex = true;
      this.editCodigo = false;
      this.dialogPresupuestoLinea = true;
    },
    addItem() {
      this.editCodigo = true;

      // Inicializar itemPresupuestoLinea con valores por defecto
      this.itemPresupuestoLinea = {
        id: "",
        id_cuenta_contable: "",
        id_centro_costo: "",
        tipo_presupuesto: "COM",
        mes: [],
        detalle: "",
        monto: "0",
        id_servicio: "",
        id_familia: [],
        id_tipo_aprobacion: "",
      };

      let cc = this.centroCostos.find((s) => s.descripcion === "MKETING");
      if (cc) {
        this.itemPresupuestoLinea.id_centro_costo = cc.id;
      }

      let servicio = this.servicios.find((s) => s.descripcion === "OTRO");
      if (servicio) {
        this.itemPresupuestoLinea.id_servicio = servicio.id;
      }

      let tipo = this.tipoAprobaciones.find((s) => s.descripcion === "OTRO");
      if (tipo) {
        this.itemPresupuestoLinea.id_tipo_aprobacion = tipo.id;
      }

      this.dialogPresupuestoLinea = true;
    },

    close() {
      this.dialogPresupuestoLinea = false;
      this.limpiar();
    },

    limpiar() {
      this.itemPresupuestoLinea = {
        id: "",
        id_cuenta_contable: "",
        id_centro_costo: "",
        tipo_presupuesto: "COM",
        mes: [],
        detalle: "",
        monto: "0",
        id_servicio: "",
        id_familia: [],
        id_tipo_aprobacion: "",
      };
      this.mensajeError = false;
      this.error = "";
      this.snackbar = false;
      this.validaMensaje = [];
      this.editedIndex = false;
      this.esEdicionGrupo = false; // Resetear la variable de edición de grupo
    },
    limpiarUpload() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },
    limpiarServicio() {
      this.codigoServicio = "";
      this.descripcionServicio = "";
      this.id_nitServicio = "";
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      var mesString = this.itemPresupuestoLinea.mes[0];
      var famString = this.itemPresupuestoLinea.id_familia[0];

      if (this.editedIndex === true) {
        //codigo para editar
        let me = this;
        axios
          .put("api/presupuesto_lineas/ActualizarCom", {
            id: me.itemPresupuestoLinea.id,
            id_presupuesto: me.id_presupuesto,
            id_cuenta_contable: me.itemPresupuestoLinea.id_cuenta_contable,
            id_centro_costo: me.itemPresupuestoLinea.id_centro_costo,
            tipo_presupuesto: me.itemPresupuestoLinea.tipo_presupuesto || "COM",
            mes: mesString,
            monto: me.itemPresupuestoLinea.monto,
            id_servicio: me.itemPresupuestoLinea.id_servicio,
            detalle: me.itemPresupuestoLinea.detalle,
            id_familia: famString,
            id_tipo_aprobacion: me.itemPresupuestoLinea.id_tipo_aprobacion,
            EditedBy: me.usuario,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        const crearCom = {
           id: me.esEdicionGrupo ? me.itemPresupuestoLinea.id : "",
            codigo: me.codigo,
            id_presupuesto: me.id_presupuesto,
            id_cuenta_contable: me.itemPresupuestoLinea.id_cuenta_contable,
            id_centro_costo: me.itemPresupuestoLinea.id_centro_costo,
            tipo_presupuesto: me.itemPresupuestoLinea.tipo_presupuesto || "COM",
            mes: me.itemPresupuestoLinea.mes,
            monto: me.itemPresupuestoLinea.monto,
            id_servicio: me.itemPresupuestoLinea.id_servicio,
            detalle: me.itemPresupuestoLinea.detalle,
            id_familia: me.itemPresupuestoLinea.id_familia,
            id_tipo_aprobacion: me.itemPresupuestoLinea.id_tipo_aprobacion,
            EditedBy: me.usuario,
            InsertedBy: me.codigoSac,
            esGrupo: me.esEdicionGrupo,
        };
        console.log("crearCom", crearCom);

        axios
          .post("api/presupuesto_lineas/CrearCom", crearCom)
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    guardarServicio() {
      if (this.validarServicio() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      let me = this;
      axios
        .post("api/servicios/crear", {
          codigo: me.codigoServicio,
          descripcion: me.descripcionServicio,
          id_nit: me.id_nitServicio,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.closeServicio();
          me.selectServicio();
          me.$store.dispatch("setSnackbar", {
            text: " Servicio creado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    guardarReemplazar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      let me = this;
      axios
        .post("api/presupuesto_lineas/CrearComBorrarDuplicados", {
          codigo: me.codigo,
          id_presupuesto: me.id_presupuesto,
          id_cuenta_contable: me.itemPresupuestoLinea.id_cuenta_contable,
          id_centro_costo: me.itemPresupuestoLinea.id_centro_costo,
          tipo_presupuesto: me.itemPresupuestoLinea.tipo_presupuesto || "COM",
          mes: me.itemPresupuestoLinea.mes,
          monto: me.itemPresupuestoLinea.monto,
          id_servicio: me.itemPresupuestoLinea.id_servicio,
          detalle: me.itemPresupuestoLinea.detalle,
          id_familia: me.itemPresupuestoLinea.id_familia,
          id_tipo_aprobacion: me.itemPresupuestoLinea.id_tipo_aprobacion,
          EditedBy: me.usuario,
          InsertedBy: me.usuario,
        })
        .then(function (response) {
          me.dialogReemplazar = false;
          me.mensajeError = false;
          me.close();
          me.listar();
          me.limpiar();
          me.$store.dispatch("setSnackbar", {
            text: " Los registros fueron guardados exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    validarDuplicados() {
      /*let me = this;
      if (this.editedIndex == false) {
        axios
          .post("api/presupuesto_lineas/validarDuplicadosCom", {
            codigo: me.codigo,
            id_presupuesto: me.id_presupuesto,
            id_cuenta_contable: me.itemPresupuestoLinea.id_cuenta_contable,
            id_centro_costo: me.itemPresupuestoLinea.id_centro_costo,
            tipo_presupuesto: me.itemPresupuestoLinea.tipo_presupuesto || "COM",
            mes: me.itemPresupuestoLinea.mes,
            monto: me.itemPresupuestoLinea.monto,
            id_servicio: me.itemPresupuestoLinea.id_servicio,
            detalle: me.itemPresupuestoLinea.detalle,
            id_familia: me.itemPresupuestoLinea.id_familia,
            id_tipo_aprobacion: me.itemPresupuestoLinea.id_tipo_aprobacion,
          })
          .then(function (response) {
            if (response.data == "") {
              me.mensajeError = false;
            } else {
              me.mensajeError = true;
              me.error = response.data;
            }
            me.windowWidth = window.innerWidth;
            me.windowHeigth = window.innerHeight;
          })
          .catch(function (error) {
            console.log("Error");
          });
      }*/
    },

    validar() {
      this.valida = 0;
      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },
    validarServicio() {
      this.valida = 0;
      Object.keys(this.formServicio).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/presupuesto_lineas/activar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    borrarItem() {
      let me = this;
      axios
        .put(
          "api/presupuesto_lineas/Eliminar/" +
            me.itemPresupuestoLinea.id +
            "/" +
            me.usuario,
          {}
        )
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.dialogBorrar = false;
          me.$store.dispatch("setSnackbar", {
            text: response.data,
            color: "success",
          });
        })
        .catch(function (error) {
          me.dialogBorrar = false;
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    borrarItems() {
      let me = this;
      axios
        .put(
          "api/presupuesto_lineas/EliminarVarios",
          this.selectLineaPresupuesto
        )
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.dialogBorrar = false;
          me.selectLineaPresupuesto = [];
          me.$store.dispatch("setSnackbar", {
            text: response.data,
            color: "success",
          });
        })
        .catch(function (error) {
          me.dialogBorrar = false;
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    duplicarItem() {
      let me = this;
      axios
        .put(
          "api/presupuesto_lineas/Duplicar/" +
            me.itemPresupuestoLinea.id +
            "/" +
            me.usuario,
          {}
        )
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.dialogDuplicar = false;

          me.$store.dispatch("setSnackbar", {
            text: response.data,
            color: "success",
          });
        })
        .catch(function (error) {
          me.dialogDuplicar = false;
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    duplicarItems() {
      let me = this;
      axios
        .put(
          "api/presupuesto_lineas/DuplicarVarios",
          this.selectLineaPresupuesto
        )
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.dialogDuplicar = false;
          me.selectLineaPresupuesto = [];
          me.$store.dispatch("setSnackbar", {
            text: response.data,
            color: "success",
          });
        })

        .catch(function (error) {
          me.dialogDuplicar = false;
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    //Método para verificar si está agrupado por detalle
    esAgrupadoPorDetalle(group) {
      // Verificamos que el grupo exista y no sea vacío
      if (!group || typeof group !== 'string') {
        return false;
      }
      
      // Verificamos si algún item del grupo tiene el campo detalle igual al valor del grupo
      // Esto indica que el agrupamiento es por la columna "detalle"
      return this.presupuesto_lineas.some(item => item.detalle === group);
    },

    //Método para abrir el diálogo de edición en grupo
    abrirEdicionEnGrupo(items, group) {
      // Limpiar el formulario primero
      this.limpiar();
      
      // Obtener los meses únicos del grupo
      const mesesUnicos = [...new Set(items.map(item => item.mes))];
      
      // Obtener las familias únicas del grupo
      const familiasUnicas = [...new Set(items.map(item => item.id_familia))];
      
      // Calcular el subtotal del grupo y redondear a dos decimales
      const subtotal = this.calcularSubtotal(items).toFixed(2);

      // Configurar itemPresupuestoLinea con los datos del grupo
      this.itemPresupuestoLinea = {
        id: items.map(item => item.id).join(','), // Unir IDs si hay varios
        id_cuenta_contable: items[0].id_cuenta_contable || "",
        id_centro_costo: items[0].id_centro_costo || "",
        tipo_presupuesto: "COM",
        mes: mesesUnicos,
        detalle: group, // El nombre del grupo es el detalle
        monto: subtotal.toString(),
        id_servicio: items[0].id_servicio || "",
        id_familia: familiasUnicas,
        id_tipo_aprobacion: items[0].id_tipo_aprobacion || "",
      };
      
      // Marcar como edición de grupo
      this.editedIndex = false; // Dejarlo en false para que se edite el registro existente
      this.editCodigo = true;
      this.esEdicionGrupo = true; // Marcar que es una edición de grupo
      
      // Abrir el diálogo principal
      this.dialogPresupuestoLinea = true;
    },

    

    //Método para calcular el subtotal de los elementos agrupados
    calcularSubtotal(items) {
      if (!items || items.length === 0) return 0;
      return items.reduce((total, item) => total + (parseFloat(item.monto) || 0), 0);
    },

    //Devuelve un entero entre 1 y 12 convertido a mes en letras, si mayus=true -> se devuelven mayúsculas
    enteroaMeses(numeroMes, mayus) {
      var meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      var mesLetras = "";

      if (!isNaN(numeroMes) && numeroMes >= 1 && numeroMes <= 12) {
        mayus
          ? (mesLetras = meses[numeroMes - 1].toUpperCase())
          : (mesLetras = meses[numeroMes - 1]);
      }
      return mesLetras;
    },

    filtroCuenta(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCuentaValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchCuentaValue.toLowerCase());
    },
    filtroMes(value) {
      var val = value.toString();
      var a = true;
      // If this filter has no value we just skip the entire filter.
      if (!this.searchMesValue) {
        return true;
      }

      //verificar si el mes completo se corresponde a la búsqueda
      value == this.searchMesValue ? (a = true) : (a = false);
      return a;
    },
  },
};
</script>
